import React, { useState, useEffect } from 'react';
import { db, storage, auth } from '../../../Firebase/Firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import './perfilNegocio.css';
import Navbar from '../../../Components/NavBarAirbnbStyle';
import Footer from '../../../Components/footer';
import NavbarMobileVersion from '../../../Components/NavBar/NavBarMobileVersion';
const EditarPerfil = () => {
  const [servicios, setServicios] = useState([]);
  const [uid, setUid] = useState(null);
  const [fase, setFase] = useState(0);

  const cargarServicios = async (uid) => {
    const q = query(collection(db, 'servicios'), where('uid', '==', uid));
    const snapshot = await getDocs(q);
    const datos = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setServicios(datos);
  };
  const pasos = ['nombre', 'descripcion', 'telefono', 'foto'];
  const [pasoActual, setPasoActual] = useState(0);

  const avanzarPaso = () => setPasoActual((prev) => Math.min(prev + 1, pasos.length));
  const retrocederPaso = () => setPasoActual((prev) => Math.max(prev - 1, 0));

  useEffect(() => {
    if (uid) cargarServicios(uid);
  }, [uid]);
  const [perfil, setPerfil] = useState({
    tipo: 'persona',
    nombre: '',
    descripcion: '',
    telefono: '',
    foto: null,
    fotoURL: '',
  });
  const [uploading, setUploading] = useState(false);
  const [mensaje, setMensaje] = useState('');

  // Detectar usuario logueado y cargar datos
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUid(user.uid);
        const userRef = doc(db, 'usuarios', user.uid);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const perfil = data.perfilNegocio || {};
          setPerfil({
            tipo: perfil.tipo || 'persona',
            nombre: perfil.nombre || data.name || '',
            descripcion: perfil.descripcion || '',
            telefono: perfil.telefono || '',
            foto: null,
            fotoURL: perfil.fotoURL || '',
          });
          setFase(data.fase || 0);
        }
      }
    });

    return () => unsubscribe();
  }, []);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'foto') {
      setPerfil({ ...perfil, foto: files[0] });
    } else {
      setPerfil({ ...perfil, [name]: value });
    }
  };
  const [asistenteActivo, setAsistenteActivo] = useState(false);

  // Detectamos si es necesario mostrar el asistente
  useEffect(() => {
    if (perfil.nombre === '' && perfil.descripcion === '' && perfil.telefono === '') {
      setAsistenteActivo(true); // primera vez
    }
  }, [perfil]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!uid) return;

    setUploading(true);
    setMensaje('');

    try {
      let fotoURL = perfil.fotoURL;

      if (perfil.foto) {
        const storageRef = ref(storage, `fotosPerfiles/${uuidv4()}_${perfil.foto.name}`);
        await uploadBytes(storageRef, perfil.foto);
        fotoURL = await getDownloadURL(storageRef);
      }

      const userRef = doc(db, 'usuarios', uid);
      await updateDoc(userRef, {
        perfilNegocio: {
          tipo: perfil.tipo,
          nombre: perfil.nombre,
          descripcion: perfil.descripcion,
          telefono: perfil.telefono,
          fotoURL,
          fechaActualizacion: new Date(),
        }
      });

      setMensaje('¡Perfil actualizado exitosamente!');
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      setMensaje('Ocurrió un error al guardar los datos.');
    }

    setUploading(false);
  };
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);


  return (
    <>
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div classname="form-space" style={{ backgroundColor: isDarkMode ? '#1f1f1f' : '#fff',alignContent: 'center', width: '100%',textAlign: 'center' }}>
        <form onSubmit={handleSubmit} className="form-corporate" style={{ backgroundColor: isDarkMode ? '#1f1f1f' : '#fff', color: isDarkMode ? '#fff' : '#000', width: '100%',margin: 'auto' ,marginTop: '80px' }}>
          <h2 className="text-xl font-bold">Perfil de Negocio</h2>
          <select name="tipo" value={perfil.tipo} onChange={handleChange} className="w-full p-2 border rounded">
            <option value="persona">Persona</option>
            <option value="marca">Marca</option>
          </select>
          <input type="text" name="nombre" placeholder="Nombre" value={perfil.nombre} onChange={handleChange} required className="w-full p-2 border rounded" />
          <textarea name="descripcion" placeholder="Descripción del perfil" value={perfil.descripcion} onChange={handleChange} className="w-full p-2 border rounded" />
          <input type="text" name="telefono" placeholder="Teléfono" value={perfil.telefono} onChange={handleChange} className="w-full p-2 border rounded" />
          <label className='label-forms'>Foto de perfil o Logo</label>
          <input type="file" name="foto" accept="image/*" onChange={handleChange} className="w-full p-2" />
          {perfil.fotoURL && (
            <img src={perfil.fotoURL} alt="Foto de perfil" className="w-24 h-24 object-cover rounded-full mx-auto" />
          )}

          <button type="submit" disabled={uploading} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            {uploading ? 'Guardando...' : 'Guardar Cambios'}
          </button>

          {mensaje && <p className="mensaje">{mensaje}</p>}
        </form></div>

      <div className="servicios-lista mt-5">
        <h3>Servicios de tu perfil (Haz clic para editar)</h3>

        {servicios.length === 0 ? (
          <button
            className="btn-agregar-servicio"
            onClick={() => window.location.href = '/crear-servicio'}
          >
            ➕ Crear nuevo servicio
          </button>
        ) : (
          <>
            <button
              className="btn-agregar-servicio"
              onClick={() => window.location.href = '/crear-servicio'}
            >
              ➕ Crear nuevo servicio
            </button>

            <div className="grid-servicios">
              {servicios.map((servicio) => (
                <div
                  key={servicio.id}
                  className="servicio-card"
                  onClick={() => window.location.href = `/editar-servicio/${servicio.id}`}
                  title="Haz clic para editar este servicio"
                >
                  {servicio.imagenURL && (
                    <img src={servicio.imagenURL} alt={servicio.titulo} />
                  )}
                  <h4>{servicio.titulo}</h4>
                  <p>{servicio.descripcion}</p>
                  <span className="editar-servicio">✏️ Editar</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Footer /></>
  );
};

export default EditarPerfil;
